import React, {Component} from 'react';
import {Redirect} from "react-router";

class Home extends Component {
  // constructor(props) {
  //   super(props);
  // }

  render() {
    return (
      <Redirect to='/bids/'/>
    );
  }
}

Home.propTypes = {};

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js